export enum LogLevel {
    TRACE,
    INFO,
    WARN,
    ERROR
}